export default __webpack_public_path__ + "static/media/riftbound_common.1bc4363a.svg";